import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

type Payload = uui.domain.actions.rpc.user.UpdateUserAction['payload']

/**
 * Update a user
 *
 * @private
 */
export const updateUser = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  Payload,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/user/update', async (payload: Payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/user/updateUser', {
      category: 'rpc',
      type: 'rpc/user/updateUser',
      payload,
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main('Unknown error on {updateUser}', { tags: ['rpc', 'user'] }, 'error')

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: 'Update User Failed',
      error,
    })
  }
})
